import { render, staticRenderFns } from "./DoctotBooking.vue?vue&type=template&id=74b22c8e&scoped=true"
import script from "./DoctotBooking.vue?vue&type=script&lang=js"
export * from "./DoctotBooking.vue?vue&type=script&lang=js"
import style0 from "./DoctotBooking.vue?vue&type=style&index=0&id=74b22c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b22c8e",
  null
  
)

export default component.exports